import { css, cx } from '@linaria/core'
import type { FC, HTMLProps } from 'react'

import { fragments, style } from '#styles/index'
import { HeaderTabEntry } from './HeaderTabs'

const tabLinkClass = css`
  cursor: pointer;
  padding: 0 10px 2.5px 10px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  color: ${style.theme.textDefault};
  border-bottom: 1px solid ${style.theme.borderSurface};
  transition: ease 0.25s border-color;

  ${fragments.textStyle.body.m.condensedBold};

  &.active {
    border-bottom: 2px solid ${style.theme.textAccent};
    color: ${style.theme.textAccent};
  }
`

export const NavLinkTabHeader: FC<HTMLProps<HTMLDivElement> & { active?: boolean }> = ({ children, className, active, ...props }) => {
  return (
    <div {...props} className={cx(tabLinkClass, className, active && 'active')}>
      <HeaderTabEntry>{children}</HeaderTabEntry>
    </div>
  )
}
